import { render, staticRenderFns } from "./Sorts.vue?vue&type=template&id=3c6ad0f2&lang=pug"
import script from "./Sorts.vue?vue&type=script&lang=js"
export * from "./Sorts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports